import React,{ useEffect, useState } from "react";
import { Link } from "react-router-dom";
import person1 from "assets/images/1.jpg";
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import { validateEmail } from "components/Validate/email"
import { validateNumber } from "components/Validate/number"
import postData from "httpClients/instance"
import Toast from "react-bootstrap/Toast"
export default function ModalEditStudent({open, closeModal, user_id, firstname, lastname, gender, phone, email, setSuccesToast, user_type}){
    const [valUserId, setValUserId] = useState("");
    const [valTitleName, setValTitleName] = useState("นาย");
    const [valFirstname, setValFirstname] = useState("");
    const [valLastname, setValLastname] = useState("");
    const [statusFill, setStatusFill] = useState(false);
    const [valEmail, setValEmail] = useState("");
    const [valPhone, setValPhone] = useState("");
    const [valGender, setValGender] = useState("male");
    const [statusEmail, setStatusEmail] = useState(false);
    
    const [statusActive, setStatusActive] = useState(true);
    const [modalAlertDetail, setModalAlertDetail] = useState(false);
    const [modalAlertOpen, setModalAlertOpen] = useState(false);
    useEffect(() => {
        setValUserId(user_id)
        setValFirstname(firstname)
        setValLastname(lastname)
        setValEmail(email)
        setValPhone(phone)
        // alert(gender)
        setValGender(gender)
    },[open])
    const handleValUserId = e => {
        setValUserId(e.target.value)
    }
    const handleTitleName = e => {
        setValTitleName(e.target.value)
    }
    const handleFirstname = e => {
        setValFirstname(e.target.value)
    }
    const handleLastname = e => {
        setValLastname(e.target.value)
    }
    const handleEmail = e => {
        setValEmail(e.target.value)
    }
    const handlePhone = e => {
        const value = e.target.value
        if(validateNumber(value)){
            setValPhone(value)
        }
    }
    const handleGender = e => {
        setValGender(e.target.value)
    }
    const handleSend = e => {
        chkFill()
    }
    const handleStatusActive = e => {
        setStatusActive(e.target.checked)
    }
    const sendDataUserEdit = async () =>{
        let token = localStorage.getItem("jwt");
        const data={
            jwt: token,
            user_id : valUserId,
            firstname : valFirstname,
            lastname : valLastname,
            email: valEmail,
            phone: valPhone,
            gender: valGender,
            department: 1,
            school: 1,
            status_active: 1
        }
        const responds = await postData(`/import-users-management/edit_${user_type}_one.php`,data);
        closeModal()
        if(responds.message === "successful"){
            setSuccesToast({open:true, title:"แก้ไขข้อมูลนิสิตสำเร็จ"})
            await localStorage.setItem('jwt', responds.jwt); 
            window.location.reload();
        }else{
            window.location.reload();
        }
    }
    const chkFill = () => {
        setStatusFill(false)
        setStatusEmail(false)
        if(valUserId !== "" && valFirstname !== "" && valLastname !== ""){
            setStatusFill(false)
            if(validateEmail(valEmail)){
                setStatusFill(false)
                setStatusEmail(false)
                sendDataUserEdit()
            }else{
                setStatusEmail(true)
            }
        }else{
            setStatusFill(true)
        }
    }
    return (
        <div>
            <Modal show={open} onHide={closeModal} size="lg">
                <Modal.Header closeButton>
                    <h5 className="modal-title" id="settingTeachingEvaluationProfessorLabel">แก้ไขข้อมูลส่วนตัว</h5>
                </Modal.Header>
                <Modal.Body>
                
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label htmlFor="ชื่อ">ชื่อ</label>
                                    <input className="form-control" id="ชื่อ" type="text" placeholder="กรอก ชื่อ" value={valFirstname} onChange={handleFirstname}/>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label htmlFor="นามสกุล">นามสกุล</label>
                                    <input className="form-control" id="นามสกุล" type="text" placeholder="กรอก นามสกุล" value={valLastname} onChange={handleLastname}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label htmlFor="อีเมล">อีเมล</label>
                                    <input className="form-control" id="อีเมล" type="text" placeholder="กรอก อีเมล" value={valEmail} onChange={handleEmail}/>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label htmlFor="เบอร์โทร">เบอร์โทร</label>
                                    <input className="form-control" maxlength="10" id="เบอร์โทร" type="text" placeholder="กรอก เบอร์โทร" value={valPhone} onChange={handlePhone}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="row">
                                <div className="col-md-6 form-group mb-3">
                                    <label htmlFor="picker1">เพศ</label>
                                    <select className="form-control" onChange={handleGender} value={valGender}>
                                        <option value="male">ชาย</option>
                                        <option value="female">หญิง</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {
                            statusFill &&
                            <div className="col-md-12 mb-3">
                                <span className="fill-empty-text">กรอกข้อมูลไม่ครบ</span>
                            </div>
                        }
                        {
                            statusEmail &&
                            <div className="col-md-12 mb-3">
                                <span className="fill-empty-text">*รูปแบบอีเมลไม่ถูกต้อง</span>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="info" onClick={handleSend}>
                        บันทึก
                    </Button>
                </Modal.Footer>
            </Modal>
        </div> 
    );
}